
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('rect',{staticClass:"a",attrs:{"x":".75","y":"4.5","width":"22.5","height":"15","rx":"1.5","ry":"1.5"}}),_c('path',{staticClass:"a",attrs:{"d":"M15.687 9.975L19.5 13.5M8.313 9.975L4.5 13.5M22.88 5.014l-9.513 6.56a2.406 2.406 0 01-2.734 0L1.12 5.014"}})])
          )
        }
      }
    